@if (contact) {
  <app-summary-section [stepRoute]="contactRoute" heading="CONTACT.HEADING">
    <p class="section-heading">
      {{ "CONTACT.CONNECTION_HOLDER_TITLE" | translate }}
    </p>

    <div class="section-fields-container">
      <app-contact-details [contactDetails]="contact.basicData" />
    </div>

    <div class="section-fields-container">
      <app-summary-section-field
        [value]="
          (contact.hasDifferentAddress ? 'COMMON.NO' : 'COMMON.YES') | translate
        "
        label="CONTACT.DIFFERENT_REQUESTER_ADDRESS"
      />
    </div>

    @if (contact.hasDifferentAddress) {
      <p class="section-heading">
        {{ "CONTACT.RESIDENTIAL_ADDRESS_TITLE" | translate }}
      </p>

      @if (contact.differentAddress) {
        <div class="section-fields-container">
          <app-address [address]="contact.differentAddress" />
        </div>
      }
    }

    <div class="section-fields-container">
      <app-summary-section-field
        [value]="'CONTACT.ROLE.TYPES.' + contact.role | translate"
        label="CONTACT.ROLE.TITLE"
      />
    </div>

    @if (contact.role === role.AUTHORIZED_REPRESENTATIVE) {
      <div class="section-fields-container">
        <app-summary-section-field
          [value]="contact.authorizedRepresentativeRole"
          label="CONTACT.YOUR_ROLE"
        />
      </div>
    }

    @if (contact.role !== role.CONNECTION_HOLDER) {
      <p class="section-heading">
        {{ "CONTACT.YOUR_CONTACT_DETAILS" | translate }}
      </p>
      <div class="section-fields-container">
        <app-contact-details
          [contactDetails]="contact.onBehalfContactDetails!.basicData"
        />

        @if (contact.role === role.INSTALLER) {
          <app-summary-section-field
            [value]="contact.installerDetails?.gridOperator"
            label="CONTACT.INSTALLER.GRID_OPERATOR"
          />
          <app-summary-section-field
            [value]="contact.installerDetails?.registrationNumber"
            label="CONTACT.INSTALLER.REGISTRATION_NUMBER"
          />
          <app-summary-section-field
            [value]="contact.installerDetails?.companyName"
            label="CONTACT.INSTALLER.COMPANY_NAME"
          />
        }
      </div>

      @if (contact.onBehalfContactDetails) {
        <div class="section-fields-container">
          <app-address [address]="contact.onBehalfContactDetails.address" />
        </div>
      }

      <p class="section-heading">
        {{ "CONTACT.POWER_OF_ATTORNEY.TITLE" | translate }}
      </p>

      <div class="section-fields-container">
        <app-summary-section-field
          [value]="
            (contact.onBehalfContactDetails?.powerOfAttorney
              ? 'COMMON.YES'
              : 'COMMON.NO'
            ) | translate
          "
          label="CONTACT.POWER_OF_ATTORNEY.DECLARATION"
        />
        @if (contact.onBehalfContactDetails?.powerOfAttorneyDocument) {
          <app-summary-section-field
            [value]="
              contact.onBehalfContactDetails?.powerOfAttorneyDocument?.name
            "
            label="CONTACT.POWER_OF_ATTORNEY.DOCUMENT"
          />
        }
      </div>
    }
  </app-summary-section>
}
